import { render, staticRenderFns } from "./LegoModalComentarios.vue?vue&type=template&id=124996db&scoped=true"
import script from "./LegoModalComentarios.vue?vue&type=script&lang=js"
export * from "./LegoModalComentarios.vue?vue&type=script&lang=js"
import style0 from "./LegoModalComentarios.vue?vue&type=style&index=0&id=124996db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124996db",
  null
  
)

export default component.exports